"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPageContentEntry = void 0;
const getClient_1 = require("./utils/getClient");
const getEntryByContentType_1 = require("./utils/getEntryByContentType");
const getPageContentEntry = async ({ space, accessToken, host, contentType, locale, environment, include = 0, trackingApplicationName }) => {
    const client = (0, getClient_1.getClient)({ space, accessToken, host, environment });
    const content = await (0, getEntryByContentType_1.getEntryByContentType)({
        client,
        contentType,
        locale,
        include,
        space,
        trackingApplicationName
    });
    return content;
};
exports.getPageContentEntry = getPageContentEntry;
//# sourceMappingURL=getPageContentEntry.js.map